/* ============================================================================
   sf-reviews.js — REV-01 Bewertungen (snippets/sf-reviews.liquid), 24.09.2026

   Die Karten kommen serverseitig aus den Judge.me-Metafeldern. Dieses Skript
   - faltet nach data-rows Reihen die übrigen Karten ein und blendet
     "Alle … Bewertungen anzeigen" / "Weniger anzeigen" ein (Handy-Wischreihe:
     kein Falten),
   - lädt beim Aufklappen fehlende Bewertungen über die öffentliche
     Judge.me-Schnittstelle (reviews_for_widget, CORS offen, 30 je Seite) und
     baut sie aus dem <template> derselben Karte,
   - kürzt lange Texte auf sechs Zeilen mit "Weiterlesen",
   - zeigt Kundenfotos groß in einem <dialog> (Pfeiltasten, Esc, Fokus zurück),
   - löst mit "Bewertung schreiben" das Judge.me-Formular aus: Der Judge.me-
     App-Block liegt unsichtbar in der Section (.sfrv-jdgm); Judge.me hängt sein
     Popup an <body>, danach geht der Fokus zurück auf unseren Button.
   Texte werden nur als textContent gesetzt, nie als HTML.
   25.09.2026: data-hidden (Judge.me-IDs aus der Section) wird auch beim
   Nachladen übersprungen; data-total zählt nur die sichtbaren Bewertungen.
   Herkunft wie in sf-review-card.liquid (transparency_badges -> Zeile).
   ============================================================================ */
(function () {
  'use strict';

  var API = 'https://judge.me/reviews/reviews_for_widget';
  var PER = 30; // mehr liefert Judge.me je Seite nicht
  var STAR = 16, GAP = 1; // RAT-01 Standard in der Karte (sf-trust-pill.css)
  var dateFmt = null;
  try {
    dateFmt = new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Europe/Berlin' });
  } catch (e) { dateFmt = null; }

  function each(nodes, fn) { Array.prototype.forEach.call(nodes, fn); }
  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  function displayName(r) {
    var raw = String(r.reviewer_name || '').trim();
    if (r.is_anonymous_reviewer || !raw) return 'Anonym';
    var parts = raw.split(/\s+/);
    var first = parts[0];
    if (first === first.toUpperCase() || first === first.toLowerCase()) {
      first = first.charAt(0).toUpperCase() + first.slice(1).toLowerCase();
    }
    return parts.length > 1 ? first + ' ' + parts[parts.length - 1].charAt(0).toUpperCase() + '.' : first;
  }

  function bodyText(r) {
    var plain = String(r.body || '').trim();
    if (plain) return plain;
    var html = String(r.body_html || '')
      .replace(/\s*<br\s*\/?>\s*/gi, '\n')
      .replace(/<\/p>\s*<p[^>]*>/gi, '\n\n');
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return String(doc.body.textContent || '').trim();
  }

  // Herkunft nach Judge.me-transparency_badges, Wortlaut wie im Judge.me-Widget
  var SRC_NAMES = { amazon: 'Amazon', aliexpress: 'AliExpress', etsy: 'Etsy' };
  function sourceLabels(r) {
    var b = (r.transparency_badges || []).join(' ');
    var src = String(r.source || '').toLowerCase();
    var out = { src: '', reward: '' };
    if (/another_provider|import/.test(b)) {
      out.src = SRC_NAMES[src] ? 'Importiert von ' + SRC_NAMES[src] : 'Bewertung gesammelt von einem anderen Anbieter';
    } else if (/written_in_google/.test(b)) {
      out.src = 'Bewertung in Google geschrieben';
    } else if (/written_in_etsy/.test(b)) {
      out.src = 'Bewertung in Etsy geschrieben';
    }
    if (/earned_reward/.test(b)) out.reward = 'Bewerter erhielt einen Rabattcode für eine zukünftige Bestellung';
    return out;
  }

  // Judge.me: pictures_urls = [{ compact, huge, original, ... }]
  function picsOf(r) {
    return (r.pictures_urls || []).map(function (p) {
      if (typeof p === 'string') return { thumb: p, full: p };
      if (!p) return null;
      return { thumb: p.compact || p.small || p.huge || p.original, full: p.huge || p.original || p.compact || p.small };
    }).filter(function (p) { return p && p.thumb; });
  }

  function fillCard(card, r) {
    card.setAttribute('data-uuid', r.uuid || '');
    var rating = Math.max(0, Math.min(5, Number(r.rating) || 0));
    var stars = card.querySelector('.sfui-trust-stars');
    if (stars) {
      var step = STAR + GAP, row = step * 4 + STAR;
      var full = Math.floor(rating);
      var fill = Math.min(row, step * full + (rating - full) * STAR);
      stars.style.setProperty('--sfui-stars-cut', ((row - fill) * 100 / row).toFixed(2) + '%');
      stars.setAttribute('aria-label', rating.toFixed(1).replace('.', ',') + ' von 5 Sternen');
    }
    var time = card.querySelector('.sfrv-card__date');
    var created = r.created_at ? new Date(r.created_at) : null;
    if (time && created && !isNaN(created.getTime())) {
      time.setAttribute('datetime', r.created_at.slice(0, 10));
      time.textContent = dateFmt ? dateFmt.format(created) : r.created_at.slice(0, 10);
    }
    var body = bodyText(r);
    var title = String(r.title || '').trim();
    var titleEl = card.querySelector('.sfrv-card__title');
    if (titleEl) {
      if (title && norm(body).indexOf(norm(title)) !== 0) titleEl.textContent = title;
      else titleEl.remove();
    }
    var bodyEl = card.querySelector('.sfrv-card__body');
    if (bodyEl) bodyEl.textContent = body;
    var who = displayName(r);
    var nameEl = card.querySelector('.sfrv-card__name');
    if (nameEl) nameEl.textContent = who;
    var avatar = card.querySelector('.sfrv-card__avatar');
    if (avatar) avatar.textContent = who.charAt(0).toUpperCase();
    var verified = card.querySelector('.sfrv-card__verified');
    if (verified && !r.verified_buyer) verified.remove();
    var labels = sourceLabels(r);
    var srcEl = card.querySelector('.sfrv-card__src:not(.sfrv-card__src--reward)');
    if (srcEl) { if (labels.src) { srcEl.textContent = labels.src; srcEl.hidden = false; } else srcEl.remove(); }
    var rewardEl = card.querySelector('.sfrv-card__src--reward');
    if (rewardEl) { if (labels.reward) { rewardEl.textContent = labels.reward; rewardEl.hidden = false; } else rewardEl.remove(); }

    var media = card.querySelector('.sfrv-card__media');
    var pics = picsOf(r);
    if (media) {
      if (!pics.length) {
        media.remove();
      } else {
        media.hidden = false;
        pics.forEach(function (p, i) {
          if (i > 3) {
            var extra = document.createElement('span');
            extra.hidden = true;
            extra.setAttribute('data-sfrv-pic-extra', '');
            extra.setAttribute('data-full', p.full);
            media.appendChild(extra);
            return;
          }
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'sfrv-card__pic';
          b.setAttribute('data-sfrv-pic', '');
          b.setAttribute('data-full', p.full);
          b.setAttribute('aria-label', 'Foto ' + (i + 1) + ' von ' + pics.length + ' vergrößern');
          var img = document.createElement('img');
          img.src = p.thumb;
          img.alt = '';
          img.width = 72;
          img.height = 72;
          img.loading = 'lazy';
          img.decoding = 'async';
          b.appendChild(img);
          if (i === 3 && pics.length > 4) {
            var more = document.createElement('span');
            more.className = 'sfrv-card__pic-more';
            more.setAttribute('aria-hidden', 'true');
            more.textContent = '+' + (pics.length - 4);
            b.appendChild(more);
          }
          media.appendChild(b);
        });
      }
    }
    return card;
  }

  function clamp(card) {
    var body = card.querySelector('.sfrv-card__body');
    var btn = card.querySelector('.sfrv-card__more');
    if (!body || !btn || card.classList.contains('is-open')) return;
    card.classList.add('is-clamped');
    if (body.clientHeight > 0 && body.scrollHeight - body.clientHeight > 2) {
      btn.hidden = false;
    } else {
      card.classList.remove('is-clamped');
      btn.hidden = true;
    }
  }

  function lightbox(root) {
    var lb = root.querySelector('[data-sfrv-lb]');
    if (!lb || typeof lb.showModal !== 'function') return null;
    var img = lb.querySelector('[data-sfrv-lb-img]');
    var count = lb.querySelector('[data-sfrv-lb-count]');
    var prev = lb.querySelector('[data-sfrv-lb-prev]');
    var next = lb.querySelector('[data-sfrv-lb-next]');
    var urls = [], idx = 0, opener = null;
    function show(i) {
      idx = (i + urls.length) % urls.length;
      img.src = urls[idx];
      img.alt = urls.length > 1 ? 'Kundenfoto ' + (idx + 1) + ' von ' + urls.length : 'Kundenfoto';
      count.textContent = urls.length > 1 ? (idx + 1) + ' / ' + urls.length : '';
      prev.hidden = next.hidden = urls.length < 2;
    }
    lb.querySelector('[data-sfrv-lb-close]').addEventListener('click', function () { lb.close(); });
    prev.addEventListener('click', function () { show(idx - 1); });
    next.addEventListener('click', function () { show(idx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
    lb.addEventListener('keydown', function (e) {
      if (urls.length > 1 && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
        e.preventDefault();
        show(idx + (e.key === 'ArrowRight' ? 1 : -1));
      }
    });
    lb.addEventListener('close', function () {
      img.removeAttribute('src');
      if (opener && opener.isConnected) opener.focus();
    });
    return function (list, start, from) {
      urls = list;
      opener = from;
      show(start);
      lb.showModal();
    };
  }

  function init(root) {
    if (root.__sfrv) return;
    root.__sfrv = true;
    var list = root.querySelector('[data-sfrv-list]');
    var tpl = root.querySelector('template[data-sfrv-tpl]');
    var foot = root.querySelector('.sfrv__foot');
    var toggle = root.querySelector('[data-sfrv-toggle]');
    var label = root.querySelector('[data-sfrv-toggle-label]');
    var status = root.querySelector('[data-sfrv-status]');
    var writeBtn = root.querySelector('[data-sfrv-write]');
    if (!list || !tpl) return;

    var shop = root.getAttribute('data-shop');
    var pid = root.getAttribute('data-product-id');
    var total = parseInt(root.getAttribute('data-total'), 10) || 0;
    var rows = parseInt(root.getAttribute('data-rows'), 10) || 3;
    var canFetch = !!(shop && pid);
    var expanded = false;
    var loading = false;
    var fetchedAll = false;
    var seen = {};
    var hiddenIds = String(root.getAttribute('data-hidden') || '').split(/[\s,]+/).filter(function (x) { return x.length > 8; });
    hiddenIds.forEach(function (x) { seen[x] = true; });
    each(list.querySelectorAll('.sfrv-card'), function (c) {
      var id = c.getAttribute('data-uuid');
      if (id) seen[id] = true;
    });
    var openLb = lightbox(root);

    function cards() { return list.querySelectorAll('.sfrv-card'); }
    function say(text) { if (status) status.textContent = text; }

    // Spalten der Kartenliste; 0 = Handy-Wischreihe (faltet nicht)
    function cols() {
      var cs = getComputedStyle(list);
      if (String(cs.gridAutoFlow).indexOf('column') === 0) return 0;
      var t = String(cs.gridTemplateColumns || '');
      if (!t || t === 'none') return 1;
      return t.split(' ').filter(Boolean).length || 1;
    }

    function applyFold() {
      var c = cols();
      var max = c ? rows * c : Infinity;
      var all = cards();
      var folded = 0;
      each(all, function (card, i) {
        var fold = !expanded && i >= max;
        card.classList.toggle('is-folded', fold);
        if (fold) folded++;
      });
      var missing = !fetchedAll && canFetch && total > all.length;
      var show = folded > 0 || missing || (expanded && all.length > max);
      if (foot) foot.hidden = !show;
      if (toggle) toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (label) label.textContent = expanded ? 'Weniger anzeigen' : 'Alle ' + total + ' Bewertungen anzeigen';
    }

    function clampAll() { each(cards(), clamp); }

    // Handy-Wischreihe: nur wenn die Liste wirklich seitlich scrollt, ist sie per Tastatur erreichbar.
    function railA11y() {
      if (list.scrollWidth > list.clientWidth + 1) {
        list.setAttribute('tabindex', '0');
        list.setAttribute('role', 'region');
        list.setAttribute('aria-label', 'Bewertungen, seitlich blättern');
      } else {
        list.removeAttribute('tabindex');
        list.removeAttribute('role');
        list.removeAttribute('aria-label');
      }
    }

    function refresh() { applyFold(); clampAll(); railA11y(); }

    function url(page) {
      return API + '?url=' + encodeURIComponent(shop) + '&shop_domain=' + encodeURIComponent(shop) +
        '&platform=shopify&page=' + page + '&per_page=' + PER + '&product_id=' + encodeURIComponent(pid);
    }

    function loadAll() {
      if (loading || !canFetch || fetchedAll) return Promise.resolve([]);
      loading = true;
      var added = [];
      if (toggle) { toggle.classList.add('is-loading'); toggle.setAttribute('aria-busy', 'true'); }
      list.setAttribute('aria-busy', 'true');
      function page(n) {
        return fetch(url(n), { credentials: 'omit' })
          .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
          .then(function (data) {
            (data.reviews || []).forEach(function (r) {
              if (!r || !r.uuid || seen[r.uuid]) return;
              seen[r.uuid] = true;
              var card = fillCard(tpl.content.firstElementChild.cloneNode(true), r);
              card.classList.add('is-new');
              list.appendChild(card);
              added.push(card);
            });
            if (typeof data.number_of_reviews === 'number') total = Math.max(0, data.number_of_reviews - hiddenIds.length);
            var pages = (data.pagination && data.pagination.total_pages) || 1;
            if (n < pages && n < 20) return page(n + 1);
          });
      }
      return page(1)
        .then(function () {
          fetchedAll = true;
          total = cards().length;
        })
        .catch(function () {
          say('Bewertungen konnten gerade nicht geladen werden. Bitte versuch es noch einmal.');
        })
        .then(function () {
          loading = false;
          if (toggle) { toggle.classList.remove('is-loading'); toggle.removeAttribute('aria-busy'); }
          list.removeAttribute('aria-busy');
          refresh();
          return added;
        });
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (expanded) {
          expanded = false;
          refresh();
          var r = toggle.getBoundingClientRect();
          if (r.top < 0 || r.bottom > window.innerHeight) toggle.scrollIntoView({ block: 'center' });
          say('Liste eingeklappt.');
          return;
        }
        var firstFolded = list.querySelector('.sfrv-card.is-folded');
        expanded = true;
        refresh();
        loadAll().then(function (added) {
          var target = firstFolded || added[0];
          if (target) target.focus({ preventScroll: true });
          say('Alle ' + cards().length + ' Bewertungen werden angezeigt.');
        });
      });
    }

    list.addEventListener('click', function (e) {
      var pic = e.target.closest('[data-sfrv-pic]');
      if (pic) {
        var media = pic.closest('.sfrv-card__media');
        var urls = [];
        each(media.querySelectorAll('[data-sfrv-pic], [data-sfrv-pic-extra]'), function (x) { urls.push(x.getAttribute('data-full')); });
        var start = Array.prototype.indexOf.call(media.querySelectorAll('[data-sfrv-pic]'), pic);
        if (openLb) openLb(urls, Math.max(0, start), pic);
        else window.open(urls[Math.max(0, start)], '_blank', 'noopener');
        return;
      }
      var btn = e.target.closest('.sfrv-card__more');
      if (!btn) return;
      var card = btn.closest('.sfrv-card');
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Weniger anzeigen' : 'Weiterlesen';
      card.classList.toggle('is-open', open);
      card.classList.toggle('is-clamped', !open);
    });

    // "Bewertung schreiben" -> Judge.me-Formular (App-Block unsichtbar in der Section)
    function jmBox() {
      var host = root.closest('.sfrv-section');
      return (host && host.querySelector('[data-sfrv-jdgm]')) || document.querySelector('[data-sfrv-jdgm]');
    }
    function jmButton() {
      var box = jmBox();
      if (!box) return null;
      var b = box.querySelector('.jm-action-buttons__button, .jdgm-write-rev-link');
      if (b) return b;
      var all = box.querySelectorAll('button, a');
      for (var i = 0; i < all.length; i++) {
        if (/bewertung schreiben|write a review/i.test(all[i].textContent || '')) return all[i];
      }
      return null;
    }
    function watchModal(from) {
      var wasOpen = false, t0 = Date.now();
      var iv = setInterval(function () {
        var m = document.querySelector('.jdgm-write-review-modal');
        var open = !!m && m.getBoundingClientRect().height > 0 && getComputedStyle(m).visibility !== 'hidden';
        if (open) wasOpen = true;
        if (wasOpen && !open) { clearInterval(iv); if (from.isConnected) from.focus(); }
        if (!wasOpen && Date.now() - t0 > 8000) clearInterval(iv);
      }, 250);
    }
    if (writeBtn) {
      writeBtn.addEventListener('click', function () {
        var tries = 0;
        writeBtn.classList.add('is-loading');
        writeBtn.setAttribute('aria-busy', 'true');
        (function attempt() {
          var b = jmButton();
          if (b || ++tries > 40) {
            writeBtn.classList.remove('is-loading');
            writeBtn.removeAttribute('aria-busy');
            if (b) { b.click(); watchModal(writeBtn); }
            else say('Das Bewertungsformular lädt gerade nicht. Bitte versuch es gleich noch einmal.');
            return;
          }
          setTimeout(attempt, 200);
        })();
      });
    }

    // Links aus Judge.me-Mails (#judgeme) landen bei den Bewertungen
    if (/^#judgeme(_product_reviews)?$/.test(window.location.hash)) {
      setTimeout(function () { root.scrollIntoView({ block: 'start' }); }, 400);
    }

    refresh();
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(refresh, 150);
    });

    // Serverseitig keine Karte, aber Bewertungen vorhanden: nachladen, sobald die Section naht.
    if (!cards().length && total > 0 && canFetch) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); loadAll(); }
        }, { rootMargin: '600px 0px' });
        io.observe(root);
      } else {
        loadAll();
      }
    }
  }

  function boot(scope) {
    each((scope || document).querySelectorAll('[data-sfrv]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
